var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"cursor-pointer"},[_c('a',{attrs:{"href":_vm.logoutFromOidcProvider},on:{"click":_vm.triggerRedirectPath}},[_c('text-button',{class:_vm.classes,attrs:{"label":'Se déconnecter',"size":"lg","icon":"lock","width":"2rem","height":"2rem","dark":false,"label_margin":"5"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }